import React from "react";
import { Translate } from "react-localize-redux";

import FoIcon from "../../../img/icons/FyzickaOsoba";
import FpoIcon from "../../../img/icons/FyzickaOsobaPodnikatel";
import PoIcon from "../../../img/icons/PravnickaOsoba";
import AddrIcon from "../../../img/icons/Domu";

import SquareWithShadow from "../../../img/icons/squareWithShadow";
import SvgBBIConsCertainDirection from "../../../img/icons/BBIcons_CertainDirection";
import SvgBBIconsCurrentRelation from "../../../img/icons/BBIcons_CurrentRelation";
import SvgBBIconsTaggedRelation from "../../../img/icons/BBIcons_TaggedRelation";
import Subject from "../../../img/icons/subject";
import Square from "../../../img/icons/square";
import SvgBBIconsHistoricRelation from "../../../img/icons/BBIcons_HistoricRelation";
import SvgBBIConsRelationDirection from "../../../img/icons/BBIcons_RelationDirection";
import SvgBBIconsUncertainDirection from "../../../img/icons/BBIcons_UncertainRelation";
import SvgBBIconsLessCertainDirection from "../../../img/icons/BBIcons_LessCertainDirection";
import "./chartLegend.scss";

export const legendItems = [
  {
    title: <Translate id="Report.Legend.SubjectTypes" />,
    items: [
      {
        icon: <FoIcon className="legend-icon" />,
        description: <Translate id="Report.Legend.NaturalPerson" />,
        color: "#71B7E6",
        separator: true,
      },
      {
        icon: <PoIcon className="legend-icon" />,
        description: <Translate id="Report.Legend.LegalPerson" />,
        color: "#77777B",
        separator: true,
      },
      {
        icon: <FpoIcon className="legend-icon" />,
        description: <Translate id="Report.Legend.NaturalPersonEnrepreneur" />,
        color: "#023671",
        separator: true,
      },
      {
        icon: <AddrIcon className="legend-icon" />,
        description: <Translate id="Report.Legend.Address" />,
        color: "#EE9016",
        separator: true,
      },
      {
        description: <Translate id="Report.Legend.SelfMadeSubject" />,
        color: "#AE7199",
      },
    ],
  },
  {
    title: <Translate id="Report.Legend.RelationTypes" />,
    items: [
      {
        icon: <SvgBBIconsCurrentRelation className="legend-icon" />,
        description: <Translate id="Report.Legend.CurrentRelation" />,
      },
      {
        icon: <SvgBBIconsHistoricRelation className="legend-icon" />,
        description: <Translate id="Report.Legend.HistoricalRelation" />,
      },
      {
        icon: <SvgBBIConsRelationDirection className="legend-icon" />,
        description: <Translate id="Report.Legend.RelationDirection" />,
      },
      {
        icon: <SvgBBIConsCertainDirection className="legend-icon" />,
        description: <Translate id="Report.Legend.CertainRelation" />,
      },
      {
        icon: <SvgBBIconsLessCertainDirection className="legend-icon" />,
        description: <Translate id="Report.Legend.LessCertainRelation" />,
      },
      {
        icon: <SvgBBIconsUncertainDirection className="legend-icon" />,
        description: <Translate id="Report.Legend.UncertainRelation" />,
      },
    ],
  },
  {
    title: <Translate id="Report.Legend.MarkingElements" />,
    items: [
      {
        icon: <SquareWithShadow className="legend-icon" />,
        description: <Translate id="Report.Legend.MainSubject" />,
      },
      {
        icon: <Square className="legend-icon" />,
        description: <Translate id="Report.Legend.SubjectWithWarnings" />,
      },
      {
        icon: <Subject className="legend-icon" />,
        description: <Translate id="Report.Legend.TaggedSubject" />,
      },
      {
        icon: <SvgBBIconsTaggedRelation className="legend-icon" />,
        description: <Translate id="Report.Legend.TaggedRelation" />,
      },
    ],
  },
];
